import { formatPrice } from '~utils/number';

import { MOVE_OPTIONS, DECORATE_LARGE_STRING } from './constants';

export const moveOptions = (op, current, increment, maxArrayIndex) => {
  switch (op) {
    case MOVE_OPTIONS.next:
      if (current < maxArrayIndex) {
        return current + increment;
      }

      return 0;
    case MOVE_OPTIONS.prev:
      if (current > 0) {
        return current - increment;
      }

      return maxArrayIndex;
    default:
      return current;
  }
};

export const truncate = (text, maxLength) => {
  let truncateText = text;

  if (text.length > maxLength) {
    truncateText =
      truncateText.substring(0, maxLength - DECORATE_LARGE_STRING.length) + DECORATE_LARGE_STRING;
  }

  return truncateText;
};

export const getShowName = (option, maxLength) =>
  truncate(`${option.name} ${option?.price ? ` ${formatPrice(option.price)}` : ''}`, maxLength);
